var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzz2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 43,
    viewBox: "0 0 69 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.287 30.7297V24.5807C34.287 23.497 35.4984 22.7603 36.5821 22.7603C39.2982 22.7603 41.5001 20.5584 41.5001 17.8423C41.5001 15.1261 39.2982 12.9242 36.5821 12.9242C35.4984 12.9242 34.287 12.1875 34.287 11.1038V4.95481M34.287 30.7297C34.287 32.666 32.7173 34.2358 30.7809 34.2358H24.6319C23.5483 34.2358 22.8115 35.4471 22.8115 36.5307C22.8115 39.2469 20.6097 41.4488 17.8935 41.4488C15.1773 41.4488 12.9755 39.2469 12.9755 36.5307C12.9755 35.4471 12.2387 34.2358 11.1551 34.2358H5.00603C3.0697 34.2358 1.5 32.666 1.5 30.7297L1.5 4.95482C1.5 3.01849 3.0697 1.44878 5.00603 1.44878L30.7809 1.44878C32.7173 1.44878 34.287 3.01849 34.287 4.95481M34.287 30.7297C34.287 32.666 35.8655 34.2347 37.8018 34.2347H43.9508C45.0345 34.2347 45.7712 33.0234 45.7712 31.9398C45.7712 29.2236 47.9731 27.0217 50.6892 27.0217C53.4054 27.0217 55.6073 29.2236 55.6073 31.9398C55.6073 33.0234 56.344 34.2347 57.4276 34.2347H63.5767C65.513 34.2347 67.0827 32.665 67.0827 30.7287V4.95378C67.0827 3.01746 65.513 1.44775 63.5767 1.44775L37.8018 1.44775C35.8655 1.44775 34.287 3.01849 34.287 4.95481",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzz2);
export default __webpack_public_path__ + "static/media/puzz2.2887d81413f8130153123e064e1c3aaa.svg";
export { ForwardRef as ReactComponent };